const defaultState = {
        variantOptionsViewModel:{}
}
export const dynamicOptions = (state = defaultState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};